import AdminLayout from './AdminLayout';

const AdminModerationPage = () => {
  return (
    <AdminLayout title="Content Moderation">
      <div className="max-w-6xl">
        <div className="bg-white rounded-xl border border-slate-200/80 overflow-hidden">
          {/* Header */}
          <div className="p-6 border-b border-slate-200">
            <h2 className="text-[15px] font-semibold text-slate-800">Moderation Queue</h2>
            <p className="text-[12px] text-slate-500 mt-1">Review and manage flagged content</p>
          </div>

          {/* Filter tabs */}
          <div className="flex border-b border-slate-200 px-6">
            {['All', 'Pending', 'Approved', 'Rejected'].map((filter) => (
              <button
                key={filter}
                className={`px-4 py-3 text-[13px] font-medium border-b-2 transition-colors ${
                  filter === 'Pending'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-slate-600 hover:text-slate-800'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>

          {/* Content Queue */}
          <div className="divide-y divide-slate-200">
            {[
              {
                review: 'Inappropriate language used in review',
                business: 'Restaurant ABC',
                reporter: 'John Doe',
                date: '2 hours ago',
                status: 'pending',
              },
              {
                review: 'Spam advertisement in comments',
                business: 'Service XYZ',
                reporter: 'Jane Smith',
                date: '4 hours ago',
                status: 'pending',
              },
              {
                review: 'Offensive content reported',
                business: 'Store 123',
                reporter: 'Mike Brown',
                date: '1 day ago',
                status: 'pending',
              },
            ].map((item, idx) => (
              <div key={idx} className="p-6 hover:bg-slate-50 transition-colors">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <p className="text-[13px] font-medium text-slate-800">{item.review}</p>
                    <p className="text-[12px] text-slate-500 mt-1.5">Business: {item.business}</p>
                    <p className="text-[12px] text-slate-500">Reported by: {item.reporter}</p>
                    <p className="text-[11px] text-slate-400 mt-2">{item.date}</p>
                  </div>
                  <div className="flex gap-2">
                    <button className="px-3 py-1.5 bg-emerald-50 text-emerald-600 text-[12px] font-medium rounded-lg hover:bg-emerald-100 transition-colors">
                      Approve
                    </button>
                    <button className="px-3 py-1.5 bg-red-50 text-red-600 text-[12px] font-medium rounded-lg hover:bg-red-100 transition-colors">
                      Reject
                    </button>
                    <button className="px-3 py-1.5 border border-slate-200 text-slate-600 text-[12px] font-medium rounded-lg hover:bg-slate-50 transition-colors">
                      Review
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Empty state would show here if no items */}
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminModerationPage;
